<script>

export default{
    name: "LimitTag"
}
</script>

<template>
    <div class="balance-tag">
        <span><slot>text</slot></span>
    </div>
</template>

<style scoped lang="scss">
.balance-tag {
    /* Badge */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 8px;

    border-radius: 16px;
    background: #EFF8FF;
    border: 1px solid #B2DDFF;
    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;

    span {
        /* Text */

        /* Text-xs/Medium */
        font-family: Geist, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        /* identical to box height, or 133% */
        text-align: center;

        /* Brand/700 */
        color: #175CD3;

        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;

    }
}
</style>
